var map = {
	"./flag_en.png": 580,
	"./flag_en_focus.png": 581,
	"./flag_en_icon.png": 221,
	"./flag_th.png": 582,
	"./flag_th_focus.png": 583,
	"./flag_th_icon.png": 222
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;



//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/flag_.*\.png$
// module id = 631
// module chunks = 1